import { render, staticRenderFns } from "./FormatView.vue?vue&type=template&id=19d4536d"
import script from "./FormatView.vue?vue&type=script&lang=js"
export * from "./FormatView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports